import { Fragment, memo, useMemo, useRef, useState } from 'react';
import type { INavRecord } from '../../interface.js';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from '@heroui/react';

import { useLongPress } from 'use-long-press';
import { useInViewport, useMemoizedFn, useUpdateEffect } from 'ahooks';
import isEqual from 'react-fast-compare';
import { formattedDayTitleDate } from '../DayTitle.jsx';
import { useModal } from '@ebay/nice-modal-react';
import AddModal, { type IAddModalProps } from '@/components/AddModal/index.jsx';
import { planDetailEvent } from '../../utils/event.js';
import classNames from 'classnames';

function NavDay({
  onClick,
  checked,
  startPosition,
  index,
  record,
  actions,
  onScrollTo,
  planId,
  size,
  display,
}: {
  onClick: () => void;
  checked: boolean;
  startPosition?: string;
  index: number;
  record: INavRecord;
  actions: {
    setWeather: (record: INavRecord) => void;
  };
  onScrollTo: (payload: { left: number }) => void;
  planId?: string;
  size?: string;
  display?: string;
}) {
  const { date } = record;
  const [isOpen, setIsOpen] = useState(false);
  const isSmall = size === 'sm';

  //	const ref = useRef<HTMLButtonElement>(null);

  // useLongPress(
  // 	() => {
  // 		setIsOpen(true);
  // 	},
  // 	ref,
  // 	{
  // 		onClick,
  // 		moveThreshold: { x: 30 },
  // 	},
  // );

  const bind = useLongPress(() => {
    setIsOpen(true);
  }, {});

  const ref = useRef<null | HTMLSpanElement>(null);

  const [isInViewport] = useInViewport(ref.current, {
    // callback,
    //	root: () => document.body,
    // rootMargin: "0px -50% 0px -50%",
  });

  const handleInViewport = useMemoizedFn(() => {
    if (!isInViewport && checked) {
      const element = ref.current;
      if (!element) return;
      const rect = element.getBoundingClientRect();
      const scrollLeft = element?.parentElement?.scrollLeft;
      if (scrollLeft === undefined) return;
      const scrollToPosition = rect.left + scrollLeft - 120;
      onScrollTo({ left: scrollToPosition });
    }
  });

  useUpdateEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    if (checked) {
      if (!isInViewport) {
        timer = setTimeout(handleInViewport, 100);
      }
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [checked]);

  const title = useMemo(() => {
    let result = record.date;

    if (record.date !== '总览') {
      if (display === 'no') {
        result = `DAY ${index}`;
      } else {
        result = formattedDayTitleDate(record.date).replace('周', '');
      }
    }

    return result;
  }, [record.date]);

  const addModal = useModal(AddModal);

  return (
    <Fragment>
      {!isSmall && index === 2 && (
        <span className='h-10 w-6 z-[2] inline-block shrink-0 bg-white -ml-6' />
      )}

      {!isSmall && index === 2 && (
        <span className='  bg-white z-[1]  sticky -left-[22px] leading-none -ml-[27px] pl-3 w-[27px] h-[56px] shrink-0 flex  items-center justify-center   text-xs text-gray-400 scale-[0.85]'>
          第一周
        </span>
      )}

      {!isSmall && startPosition && (
        <span
          className=' w-4  bg-gradient-to-r from-white to-white/80 rounded-r-[26px] z-[1]  sticky left-0  leading-none -ml-2 pl-4 pr-[17px] h-[56px]  flex  items-center justify-center   text-xs text-gray-400  scale-[0.85]'
          style={{
            boxShadow: '6px 0 6px -5px rgba(255,255,255,1)',
          }}
        >
          {startPosition}
        </span>
      )}

      <span
        ref={ref}
        // ref={ref}
        onClick={onClick}
        {...bind()}
        style={{
          boxShadow: checked ? '0 0 0 1px rgba(0,0,0,1)' : '',
        }}
        className={classNames(
          'origin-left select-none w-max shrink-0 transition-transform relative rounded-full flex flex-col justify-center overflow-hidden items-center bg-white border',
          {
            'z-[3]': index < 2,
            '-mr-1': !isSmall && index !== 0,
            'h-10': isSmall,
            'h-[50px]': !isSmall,
            'px-4': isSmall,
            'px-7': !isSmall && index >= 10,
            'px-[22px]': !isSmall && index < 10,
            'py-1': !isSmall,
            'border-black font-[500]': checked,
            'border-gray-200 text-gray-500': !checked,
            'scale-85 opacity-60': isOpen,
            'scale-90': !isOpen,
          }
        )}
      >
        {/* <i className=" absolute text-[56px] leading-none font-bold right-0 -top-2 text-gray-100 ">
            {index}
            <span className=" bg-gradient-to-t from-white/5  to-white/5 absolute top-0 left-0 w-full h-full" />
        </i> */}
        {!isSmall && index > 0 && (
          <span className=' absolute rounded-full left-0 top-0 w-full h-full overflow-hidden'>
            <span
              className={`absolute left-[2px] font-[din] top-0 text-xs  rounded-br-full rounded-tl-full pt-[1px] pr-[10px] pl-[11px] pb-[1.5px] scale-[0.82] origin-top-left ${
                checked
                  ? 'bg-black text-white '
                  : 'bg-gray-50/90 text-gray-400/70'
              }`}
            >
              {index}
            </span>
          </span>
        )}
        <span className={`relative   ${isSmall ? 'text-sm' : 'text-base'}`}>
          {title}
        </span>

        <span
          className={`block text-xs text-gray-500 relative scale-95 ${
            checked ? ' ' : 'opacity-60 grayscale'
          }`}
        >
          {record.weather}
        </span>
      </span>

      <Dropdown
        trigger='longPress'
        // @ts-ignore type
        isOpen={isOpen}
        onOpenChange={(open: boolean) => !open && setIsOpen(open)}
      >
        <DropdownTrigger>
          <div />
        </DropdownTrigger>
        {/* @ts-ignore type */}
        <DropdownMenu
          onAction={(key: string) => {
            if (!planId) return;
            if (key === 'add') {
              addModal.show({
                planId,
                date,
                onSuccess: () => {
                  planDetailEvent.emit('requestRefresh');
                },
              } satisfies IAddModalProps);
              return;
            }
            // STEP: 修改天气
            actions.setWeather(record);
          }}
          aria-label='Profile Actions'
          variant='flat'
        >
          <DropdownItem key='setWeather'>修改天气</DropdownItem>
          <DropdownItem key='add'>追加活动</DropdownItem>
        </DropdownMenu>
      </Dropdown>

      {!isSmall && record.weekNo && (
        <span className=' w-4 bg-white z-[4]  sticky -left-[22px]  leading-none -ml-2 pl-4 pr-[17px] h-[56px]  flex  items-center justify-center   text-xs text-gray-400  scale-[0.85]'>
          {record.weekNo}
        </span>
      )}
    </Fragment>
  );
}

export default memo(NavDay, isEqual);
